import {memo} from "react";
import { ConditionName, zIndex } from "interfaces";
import { conditions } from "helpers";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const PortraitPoll = dynamic(() => import("../../player-components/poll/portraitPoll/portraitPoll"));
const Lock = dynamic(() => import("../../player-components/lockUnlock/lock"));
const Unlock = dynamic(() => import("../../player-components/lockUnlock/unlock"));
const Subtitles = dynamic(() => import("../../player-components/subtitles/subtitles"));
const PictureInPicture = dynamic(() => import("../../player-components/pictureInPicture/pictureInPicture"));
const AutoPlayToggle = dynamic(() => import("../../player-components/toggle/autoPlayToggle"));
const SoundVolume = dynamic(() => import("../../player-components/soundVolume/soundVolume"));
const Speed = dynamic(() => import("../../player-components/speed/speed"));
const Settings = dynamic(() => import("../../player-components/settings/settings"));
const FullRate = dynamic(() => import("../../player-components/fullrate/fullrate"));
const AgeClassification = dynamic(() => import("../../player-components/ageClassification/ageClassification"));

const PortraitHeader = () => {

    useAppSelector(({ controller: { lock, activeElements } }) => ({ lock, activeElements }), shallowEqual);

    return (
        <>
            {!conditions(ConditionName.isFirstPlay) && (
                <>
                    {conditions(ConditionName.showPoll) && <PortraitPoll />}
                    <div
                        className={`pl-flex pl-flex-row-reverse pl-justify-end pl-items-center pl-gap-6 pl-mt-3 pl-mr-5 pl-absolute animate__animated animate__faster ${conditions(ConditionName.isActiveElements) ? "animate__fadeInDown" : "animate__fadeOutUp"}`}
                        style={{zIndex: zIndex.portraitHeaderIcons}}>
                        {conditions(ConditionName.isLock) ? <Lock /> : (
                            <>
                                {conditions(ConditionName.hasSubtitle) && <Subtitles />}
                                {conditions(ConditionName.showPictureInPicture) && <PictureInPicture />}
                                <AutoPlayToggle />
                                <Unlock />
                                {!conditions(ConditionName.isIOS) && <SoundVolume />}
                                {conditions(ConditionName.showSpeedIcon) && <Speed />}
                                {!conditions(ConditionName.isIOS) && <Settings />}
                            </>
                        )}
                    </div>
                    {conditions(ConditionName.showFullRate) && <FullRate />}
                    {conditions(ConditionName.showAgeClassification) && <AgeClassification />}
                </>
            )}
        </>
    )
}

export default memo(PortraitHeader);